import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services';
import { PressureClassModel } from '../../../models';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { JointCalcService } from 'src/app/Modules/idms/components/plant-manager/services/joint-calc-service.service';
import { CalculationType } from '../../../enums/calculation-type.enum';

@Component({
    selector: 'app-pressure-class',
    templateUrl: './pressure-class.component.html',
    styleUrls: ['./pressure-class.component.scss'],
})
export class PressureClassComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Input() enable: boolean;
    @Input()
    set standardId(value: string) {
        if (value) {
            this._standardId = value;
            this.form.markAllAsTouched();
            if (!this.jointCalcService.isPipeCode) this.getPressureClasses();
        }
    }
    get standardId(): string {
        return this._standardId;
    }
    destroy$ = new Subject();

    tooltip_position = 'above';
    loading: boolean = false;
    pressureClassList: PressureClassModel[];
    private _standardId: string;

    constructor(
        private iceapi: IceapiService,
        private dataService: DataService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        private router: Router,
        private jointCalcService: JointCalcService
    ) {}

    ngOnInit(): void {
        this.form.markAllAsTouched();
        if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
            this.pipespecwithPressureClass();
        }
        this.form
            .get('pressureClass')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    if ((this.router.url == '/idms/plantmanager' || this.router.url.includes('/idms/plantmanagerView')) && this.jointCalcService.isPipeCode) {
                        this.jointCalcService.selectedPressureClass.next(value);
                    }
                }
            });
    }

    getPressureClasses(): void {
        if (this.standardId != undefined) {
            this.loading = true;
            this.iceapi
                .getPressureClasses(this._standardId)
                .pipe(
                    finalize(() => {
                        this.loading = false;
                    })
                )
                .pipe(takeUntil(this.destroy$))
                .subscribe((pressureClasses) => {
                    if (pressureClasses.success === true) {
                        this.pressureClassList = pressureClasses.response;
                        this.dataService.pressureClassList = pressureClasses.response;

                        if (this.pressureClassList.length === 1) this.form.get('pressureClass').setValue(this.pressureClassList[0].pressureClassId);

                        this.cd.markForCheck();
                    } else {
                        this.user_utility.errorModelPopup(pressureClasses.message);
                    }
                });
        }
    }

    async pipespecwithPressureClass() {
        this.jointCalcService.selectedStandard.pipe(takeUntil(this.destroy$)).subscribe(async (std) => {
            this.loading = true;
            if (std && this.jointCalcService.pipeSpecpayload.lookupParams.calculationType == CalculationType.StandardFlange) {
                let pipeSpecPressureClass = await this.iceapi
                    .getPressureClasses(std)
                    .pipe(finalize(() => (this.loading = false)))
                    .toPromise();

                if (pipeSpecPressureClass.success) {
                    let pressureClassList = [...pipeSpecPressureClass.response];

                    let InputGroup = this.jointCalcService.pipeSpecpayload.lookupParams;
                    InputGroup.recordId.standardId = std;

                    InputGroup.nominal =
                        InputGroup.recordId.pressureClassId =
                        InputGroup.recordId.pipeSizeId =
                        InputGroup.recordId.flangeTypeId =
                        InputGroup.recordId.flangeFacingTypeId =
                        InputGroup.recordId.flangeMaterialId =
                        InputGroup.recordId.gasketId =
                        InputGroup.others.boltType =
                        InputGroup.recordId.boltMaterialId =
                        InputGroup.others.tighteningSpecification =
                            null;

                    this.pressureClassList = await this.jointCalcService.managePayloadForRecourdId('pressureClassId', pressureClassList);
                    this.dataService.pressureClassList = [...this.pressureClassList];

                    if (this.pressureClassList.length == 1) {
                        this.form.get('pressureClass').setValue(this.pressureClassList[0].pressureClassId);
                    }
                    if (this.dataService?.calculationData?.input?.recordId?.pressureClassId)
                        this.form.get('pressureClass').setValue(this.dataService?.calculationData?.input?.recordId?.pressureClassId);
                } else if (pipeSpecPressureClass.isCustom) {
                    this.user_utility.errorModelPopup(pipeSpecPressureClass.message);
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
